import { SetStateAction, useContext, useEffect, useState } from "react";
import { SearchResident } from "./SearchResident";
import { Stack } from "@mui/material";
import { ResidentDto } from "./dtos/ResidentDto";
import { useFindAcceptances } from "./useFindAcceptances";
import { AcceptanceDto } from "../../dtos/AcceptanceDto";
import { DisplayAcceptances } from "./DisplayAcceptances";
import VillageConsoleContext from "../../store/VillageConsoleContext";


export type AcceptanceDataRow = {
    
    acceptanceId: number;
    acceptedDateTime: string;
    department: string;
    employeeNumber: string;
    fullName: string;
    isThirdParty: boolean;
    ruleVersion: string;

};


const compareRows = ( first: AcceptanceDataRow, second: AcceptanceDataRow ) => {

    var firstDate = new Date( first.acceptedDateTime.split( '/' ).reverse( ).join( '/' ) );
    var secondDate = new Date( second.acceptedDateTime.split( '/' ).reverse( ).join( '/' ) );

    if ( firstDate > secondDate ) {

        return -1;

    }

    if ( firstDate < secondDate ) {

        return 1;

    }

    return 0;

};


const formatData = ( acceptance: AcceptanceDto ): AcceptanceDataRow => {

    const acceptedDateTime = new Date(acceptance.acceptedDateTime).toLocaleDateString( "en-AU" );
    
    return { 
        
        acceptanceId: acceptance.acceptanceId,
        acceptedDateTime,
        department: acceptance.department,
        employeeNumber: acceptance.employeeNumber,
        fullName: acceptance.fullName,
        isThirdParty: acceptance.isThirdParty,
        ruleVersion: acceptance.ruleVersion

    };

};



export const FindAcceptances: React.FC = () => {

    const [ rows, setRows ] = useState< AcceptanceDataRow[ ] >( );
    const [ isLoading, setIsLoading ] = useState< boolean >( false );

    const { getAcceptances } = useFindAcceptances( );
    const { domain } = useContext( VillageConsoleContext );

    useEffect(( ) => { 

        setRows( undefined );
        
    }, [ domain ] );


    const handleSelectResident = async( residentDto : SetStateAction< ResidentDto | undefined > ) => {

        if( !residentDto ){
            
            setRows( undefined );
            return;

        }
        
        setIsLoading( true );
        const acceptances: AcceptanceDto[] = await getAcceptances( residentDto as ResidentDto );
        setIsLoading( false );
        
        const rows : AcceptanceDataRow[ ] = [ ];
        for( const acceptance of acceptances ){

            rows.push( formatData( acceptance ) );

        }

        setRows( rows.sort( compareRows ) );

    };


    return (

        <Stack direction="column" display="flex" justifyContent="center" gap={ 3 } sx={{ marginTop: '30px' }}>
            
            <SearchResident selectResident={ handleSelectResident } isLoading={ isLoading } />
            
            { rows && rows.length > 0 && <DisplayAcceptances rows={ rows } /> }

            { rows && rows.length === 0 && <div style={{ alignSelf: 'center', color: 'red' }}>*No results found for the search criteria</div> }
        
        </Stack>

    );
    
}; 